import { ModalProps } from 'antd';
import { UpdateDonorsOwnerModalPropTypes } from 'modules/donor/types';
import { useState } from 'react';

import { ContextType } from './type';

export const useProviderValue = (): ContextType => {
  const [modalProps, setModalProps] = useState<
    ModalProps & UpdateDonorsOwnerModalPropTypes
  >();
  const [visible, setVisible] = useState(false);

  const showModal = (params?: UpdateDonorsOwnerModalPropTypes) => {
    params && setModalProps({ ...modalProps, ...params });
    setVisible(true);
  };

  const updateModalProps = (props: ModalProps) => {
    setModalProps(props);
  };

  const hideModal = () => {
    setVisible(false);
  };

  return {
    modalConfig: {
      ...modalProps,
      visible,
      hide: hideModal,
    },
    showModal,
    hideModal,
    updateModalProps,
  };
};
